export default "__VITE_ASSET__254c466c__"